import template from './sw-cms-el-preview-product-box.html.twig';
import './sw-cms-el-preview-product-box.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
